import { createAction, props } from '@ngrx/store';

export const setBookmark = createAction('[Bookmarks] Set Bookmark', props<{ documentId: number }>());

export const setBookmarkSuccess = createAction('[Bookmarks] Set Bookmark Success', props<{ response: any }>());

export const setBookmarkFailure = createAction('[Bookmarks] Set Bookmark Failure', props<{ error: any }>());

export const deleteBookmark = createAction('[Bookmarks] Delete Bookmark', props<{ documentId: number }>());

export const deleteBookmarkSuccess = createAction('[Bookmarks] Delete Bookmark Success', props<{ response: any }>());

export const deleteBookmarkFailure = createAction('[Bookmarks] Delete Bookmarks Failure', props<{ error: any }>());
